import { formatMoney } from '../../utils/currency';
import { initProductCarousels } from '../../sections/INF-ProductOverview/carousel';
import { destroyZoom } from '../ProductImages';

let theme = window.theme || {};
let Shopify = window.Shopify || {};

const updateSelectedVariant = (variant, inventory_json, product_json, firstTimeLoading) => {
  if (!variant) {
    return;
  }

  if (!firstTimeLoading) {
    // Destroy any active zoom instances before updating the variant
    destroyZoom();

    const currentVariantElement =
      document.querySelector('[data-current-variant-barcode]') || document.createElement('div');
    currentVariantElement.setAttribute('data-current-variant-barcode', variant.barcode || variant.sku);
    if (!currentVariantElement.parentElement) {
      currentVariantElement.style.display = 'none';
      document.body.appendChild(currentVariantElement);
    }

    // Set the barcode on the ProductOptions container for easier access
    const productOptionsContainer = document.querySelector('.ProductOptions');
    if (productOptionsContainer) {
      productOptionsContainer.setAttribute('data-variant-barcode', variant.barcode || variant.sku);
    }

    const variantImages = product_json.media;
    const variantBarcode = variant.barcode;
    let carouselMainHtml = '';
    let carouselThumbsHtml = '';

    if (product_json.type.includes('GIVEX')) {
      carouselMainHtml = `<div class="swiper-slide"><img class='ProductImages__image' data-product-images-slide src=${variant.featured_image.src}></div>`;
      carouselThumbsHtml = `<div class="ProductImages__thumbs-placeholder swiper-slide" data-product-images-thumb><img data-product-images-thumbs-slide src="${variant.featured_image.src}"></div>`;

      const carouselMain = document.querySelector('[data-product-images-carousel] .swiper-wrapper');
      const carouselThumbs = document.querySelector('[data-product-images-thumbs-wrapper] .swiper-wrapper');
      if (carouselMain) {
        carouselMain.innerHTML = carouselMainHtml;
      }
      if (carouselThumbs) {
        carouselThumbs.innerHTML = carouselThumbsHtml;
      }
    } else {
      /**
       * Site Performance Product Images Optimization
       * https://windsorfashions.atlassian.net/browse/WIN-6237
       * Instead of utilizing JS to update the product image, we will be using the Shopify Liquid to render the images. View the ProductImages.liquid for more details.
       */
      const altText = document.querySelector('[data-product-images-slide]').getAttribute('alt');

      if (!variantImages) {
        return;
      }

      const mediaArray = variantImages
        .map((media) => {
          const isVideo = media.media_type.includes('video');
          const fileN = isVideo ? media.preview_image.src : media.src;
          const splitV = isVideo ? 'preview_images/' : '/';

          const filename = fileN.split(splitV).pop();

          const parts = filename.split('_');
          const sortNumber = parseInt(parts[1] || '0', 10);

          return {
            sortNumber,
            mediaId: media.id,
          };
        })
        .sort((a, b) => a.sortNumber - b.sortNumber)
        .map((item) => `${item.sortNumber}:${item.mediaId}`);

      mediaArray.forEach((image) => {
        let parts = image.split(':');
        let mediaId = Number(parts[1]);
        image = variantImages.find((media) => media.id === mediaId);
        let fileSource = image.src;
        let splitValue = '/';
        const isVideo = image.media_type.includes('video');
        if (isVideo) {
          fileSource = image.preview_image.src;
          splitValue = 'preview_images/';
        }
        let url_slash_split = fileSource.split(splitValue);
        let url_last_section = url_slash_split[url_slash_split.length - 1];
        let url_style_number = url_last_section.split('_')[0];
        if (url_style_number == variantBarcode) {
          if (isVideo) {
            carouselMainHtml += `
            <div class="swiper-slide no-zoom" data-video-variant-barcode="${url_style_number}">
                <video playsinline="" id="productVideo" loop muted aria-label="Product video" autoplay poster="${fileSource}" data-video-variant-barcode="${url_style_number}" data-video-sort-order="${parts[0]}">
                  <source src="${image.sources[0].url}" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <button id="playPauseButton" aria-label="Pause video">
                  <span class="pause" aria-hidden="true">
                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0.333334V9.66667H2.66667V0.333334H0ZM5.33333 0.333334V9.66667H8V0.333334H5.33333Z" fill="black"></path>
                    </svg>
                  </span>
                  <span class="play" aria-hidden="true">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.666626 0.777802V13.2222L11.3333 7.00002L0.666626 0.777802Z" fill="black"></path>
                    </svg>
                  </span>
                  <span class="visually-hidden">Pause</span>
                </button>
            </div>
            `;
            carouselThumbsHtml += `
            <div class="ProductImages__thumbs-placeholder swiper-slide" data-video-variant-barcode="${url_style_number}">
              <video poster="${fileSource}" data-video-variant-barcode="${url_style_number}">
                <source src="${image.sources[0].url}" type="video/mp4">
              </video>
              <div class="icon-play">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.9998 0.666687C6.64784 0.666687 0.666504 6.64802 0.666504 14C0.666504 21.352 6.64784 27.3334 13.9998 27.3334C21.3518 27.3334 27.3332 21.352 27.3332 14C27.3332 6.64802 21.3518 0.666687 13.9998 0.666687ZM11.3332 18.6187V9.38135L19.3332 14L11.3332 18.6187Z" fill="white"></path>
                </svg>
              </div>
            </div>
            `;
          } else {
            let ext = fileSource.includes('.webp') ? '.webp' : '.jpg';
            let resized_image = fileSource.split(ext);
            let new_resized_url = resized_image.join('_633x715_crop_center' + ext);
            let new_resized_thumbs = resized_image.join('_137x161_crop_center' + ext);
            let zoom_url = resized_image.join('_1594x1800_crop_center' + ext);

            carouselMainHtml += `<div class="swiper-slide"><img class='ProductImages__image' alt="${altText}" data-zoom="${zoom_url}" data-product-images-slide src="${new_resized_url}"></div>`;
            carouselThumbsHtml += `<div class="ProductImages__thumbs-placeholder swiper-slide"  data-product-images-thumb><img data-product-images-thumbs-slide alt="${altText}" src="${new_resized_thumbs}"></div>`;
          }
        }
      });

      const carouselMain = document.querySelector('[data-product-images-carousel] .swiper-wrapper');
      const carouselThumbs = document.querySelector('[data-product-images-thumbs-wrapper] .swiper-wrapper');
      if (carouselMain) {
        carouselMain.innerHTML = carouselMainHtml;
      }
      if (carouselThumbs) {
        carouselThumbs.innerHTML = carouselThumbsHtml;
      }
    }

    // Dispatch event for variant change
    const variantChangeEvent = new CustomEvent('variantChange', {
      detail: {
        variant: variant,
      },
    });
    document.dispatchEvent(variantChangeEvent);

    // Update carousels
    const carouselMain = document.querySelector('[data-product-images-carousel] .swiper-wrapper');
    const carouselThumbs = document.querySelector('[data-product-images-thumbs-wrapper] .swiper-wrapper');

    if (carouselMain) {
      carouselMain.innerHTML = carouselMainHtml;
    }

    if (carouselThumbs) {
      carouselThumbs.innerHTML = carouselThumbsHtml;
    }

    // Re-initialize carousels
    initProductCarousels();

    // After carousels are updated, explicitly handle video updates
    setTimeout(() => {
      // Handle PDP videos
      const pdpContainer = document.querySelector('.ProductOverview');
      if (pdpContainer && window.PDPVideo) {
        if (!pdpContainer.pdpVideoInstance) {
          pdpContainer.pdpVideoInstance = new window.PDPVideo(document);
        }

        // Process videos for this variant
        pdpContainer.pdpVideoInstance.processVideosForVariant(variant.barcode || variant.sku);

        // Update video visibility first
        pdpContainer.pdpVideoInstance.updateVideoVisibility(variant.barcode || variant.sku, pdpContainer);

        // Listen for visibility update to reset slides
        const visibilityUpdateHandler = () => {
          const mainSwiperEl = pdpContainer.querySelector('.swiper-main');
          const thumbsSwiperEl = pdpContainer.querySelector('.swiper-thumbs');
          if (mainSwiperEl?.swiper && thumbsSwiperEl?.swiper) {
            // Update swipers to ensure all slides are registered
            mainSwiperEl.swiper.update();
            mainSwiperEl.swiper.updateSlides();
            mainSwiperEl.swiper.updateProgress();
            thumbsSwiperEl.swiper.update();
            thumbsSwiperEl.swiper.updateSlides();
            thumbsSwiperEl.swiper.updateProgress();

            // Reset to first slide
            mainSwiperEl.swiper.slideTo(0, 0, false);
            thumbsSwiperEl.swiper.slideTo(0, 0, false);

            // Update active classes manually
            const slides = thumbsSwiperEl.querySelectorAll('.swiper-slide');
            slides.forEach((slide, index) => {
              if (index === 0) {
                slide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
              } else {
                slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
              }
            });

            // Finally sync everything
            pdpContainer.pdpVideoInstance.updateCarousels();
          }

          // Remove the event listener
          pdpContainer.removeEventListener(
            window.PDPVideo.VIDEO_EVENTS.VIDEO_VISIBILITY_UPDATED,
            visibilityUpdateHandler,
          );
        };

        pdpContainer.addEventListener(window.PDPVideo.VIDEO_EVENTS.VIDEO_VISIBILITY_UPDATED, visibilityUpdateHandler);

        // Listen for carousel updates to reinitialize zoom
        const carouselUpdateHandler = () => {
          if (typeof window.reinitializeZoom === 'function') {
            window.reinitializeZoom();
          }
          pdpContainer.removeEventListener(window.PDPVideo.VIDEO_EVENTS.CAROUSELS_UPDATED, carouselUpdateHandler);
        };
        pdpContainer.addEventListener(window.PDPVideo.VIDEO_EVENTS.CAROUSELS_UPDATED, carouselUpdateHandler);
      }

      // Handle QuickView videos
      const quickViewContainer = document.querySelector('.QuickView[aria-hidden="false"]');
      if (quickViewContainer && window.PDPVideo) {
        if (!quickViewContainer.pdpVideoInstance) {
          quickViewContainer.pdpVideoInstance = new window.PDPVideo(quickViewContainer);
        }

        // Process videos for this variant
        quickViewContainer.pdpVideoInstance.processVideosForVariant(variant.barcode || variant.sku);
      }
    }, 500);

    // Initialize carousels
    if (typeof window.initProductCarousel === 'function') {
      window.initProductCarousel();
    }

    // After carousel is initialized, reinitialize zoom with a delay to ensure DOM is ready
    setTimeout(() => {
      if (typeof window.reinitializeZoom === 'function') {
        window.reinitializeZoom();
      }
    }, 500);

    const quickviewElement = document.getElementById('Quickview');
    const quickviewElement2 = document.getElementById('QuickView');

    const cartRows = [];
    if (window.cart && window.cart.items && window.cart.items.length > 0) {
      // window.cart.items.forEach((cartItem, index) => {
      window.cart.items.forEach((cartItem) => {
        var price = formatMoney(cartItem.price, theme.moneyFormat);
        price = price.replace(/[$A-Za-z,\s]+/g, '');
        if (!/^\d/.test(price)) {
          price = price.slice(1);
        }
        const cartRow = {
          productId: cartItem.product_id.toString(),
          quantity: cartItem.quantity.toString(),
          unitPrice: price,
          currency: Shopify.currency.active.toString(),
          sku: cartItem.variant_id.toString(),
        };

        cartRows.push(cartRow);
      });
    }

    if (
      (quickviewElement && quickviewElement.classList.contains('Modal--open')) ||
      (quickviewElement2 && quickviewElement2.classList.contains('Modal--open'))
    ) {
      window.monetateQ = window.monetateQ || [];

      window.monetateQ.push([
        'addProductDetails',
        [
          {
            productId: product_json.id.toString(),
            sku: variant.id.toString(),
          },
        ],
      ]);
      window.monetateQ.push(['addCartRows', cartRows]);
      window.monetateQ.push(['setPageType', 'quickview']);
      window.monetateQ.push(['trackData']);
    } else {
      window.monetateQ = window.monetateQ || [];

      window.monetateQ.push([
        'addProductDetails',
        [
          {
            productId: product_json.id.toString(),
            sku: variant.id.toString(),
          },
        ],
      ]);
      window.monetateQ.push(['addCartRows', cartRows]);
      window.monetateQ.push(['setPageType', 'product']);
      window.monetateQ.push(['trackData']);
    }
  }

  const inventory = Number(inventory_json[variant.id]);

  // update the color name
  const colorVariantValue = document.querySelector('[data-color-variant-value]');
  if (colorVariantValue) {
    colorVariantValue.innerHTML = variant.option1;
  }
  // update the style number under the title
  const styleNumberValue = document.querySelector('[data-style-number-value]');
  if (styleNumberValue) {
    styleNumberValue.innerHTML = variant.barcode;
  }
  // update size under the title
  const sizeVariantValue = document.querySelector('[data-size-variant-value]');
  const shoeSize = sizeVariantValue.getAttribute('data-size-shoe');
  if (sizeVariantValue) {
    sizeVariantValue.innerHTML = `${shoeSize == 'true' ? 'US ' : ''}${variant.option2}`;
  }
  // update low inventory message
  try {
    const lowInventoryMessage = document.querySelector('[data-low-inventory-message]');
    if (lowInventoryMessage) {
      if (inventory < 10 && inventory >= 1) {
        lowInventoryMessage.textContent = 'Almost Gone';
        lowInventoryMessage.style.display = 'block';
      } else {
        lowInventoryMessage.style.display = 'none';
      }
    }
  } catch (err) {
    console.log(err);
    console.log('updateSelectedVariant.js: Error in checking inventory');
  }

  // update Quadpay widget value on variant update and include $4 MFPP.
  const quadpay_price = (variant.price / 100 / 4 + 1).toFixed(2);
  const quadpay_money_price = `$${quadpay_price}`;
  const quadpayElement = document.querySelector('.ProductHeading__quadpay [slot="qpDisplayAmount"]');
  if (variant.price > 3500 && quadpayElement) {
    quadpayElement.innerHTML = quadpay_money_price;
  }

  const variantCents = String(variant.price).slice(-2);

  // update clearance message and badge
  const badgeClearance = document.querySelector('[data-badge-clearance]');
  if (badgeClearance) {
    if (variant.price >= variant.compare_at_price) {
      badgeClearance.style.display = 'none';
    } else {
      badgeClearance.style.display = 'block';
    }
  }

  const skuAttribute = document.querySelector('[data-sku]');
  if (skuAttribute) {
    skuAttribute.setAttribute('data-sku', variant.sku);
  }
  const variantIdAttribute = document.querySelector('[data-variant-id]');
  if (variantIdAttribute) {
    variantIdAttribute.setAttribute('data-variant-id', variant.id);
  }

  const variantChange = new CustomEvent('variantChange');
  document.dispatchEvent(variantChange);

  let finalSaleTag = product_json.tags.some((tag) => tag.toLowerCase() === 'final sale');

  const showForClearance = document.querySelector('[data-show-for-clearance]');
  if (showForClearance) {
    if (finalSaleTag || variantCents === '97' || variantCents === '96') {
      showForClearance.style.display = 'block';
    } else {
      showForClearance.style.display = 'none';
    }
  }

  // Sync the sticky nav options
  const container = document.querySelector('body'); // Adjust this if necessary to point to the correct container element
  const select1 = container.querySelector('[data-custom-option-selector="option1"] select');
  const select2 = container.querySelector('[data-custom-option-selector="option2"] select');

  if (select1) {
    select1.value = variant.option1;
  }

  if (select2) {
    select2.value = variant.option2;
  }

  // Sync secondary sticky nav options
  document
    .querySelectorAll('[data-secondary-color-variant-selector]')
    .forEach((el) => el.classList.remove('ProductOption__variant--selected'));
  document
    .querySelectorAll('[data-secondary-size-variant-selector]')
    .forEach((el) => el.classList.remove('ProductOption__variant--selected'));

  const secondaryColorSelector = document.querySelector(
    `[data-secondary-color-variant-selector][data-value="${variant.option1}"]`,
  );
  if (secondaryColorSelector) secondaryColorSelector.classList.add('ProductOption__variant--selected');

  const secondarySizeSelector = document.querySelector(
    `[data-secondary-size-variant-selector][data-value="${variant.option2}"]`,
  );
  if (secondarySizeSelector) secondarySizeSelector.classList.add('ProductOption__variant--selected');
  // Sync Sold Out or Unavailable status on mobile sticky
  setTimeout(() => {
    document.querySelectorAll('[data-secondary-size-variant-selector]').forEach((el) => {
      el.classList.remove('ProductOption__variant--unavailable');
      el.classList.remove('ProductOption__variant--sold-out');
    });

    document.querySelectorAll('.ProductOption__variant--unavailable[data-size-variant-selector]').forEach((el) => {
      const val = el.getAttribute('data-value');
      const target = document.querySelector(`[data-secondary-size-variant-selector][data-value="${val}"]`);
      if (target) target.classList.add('ProductOption__variant--unavailable');
    });

    document.querySelectorAll('.ProductOption__variant--sold-out[data-size-variant-selector]').forEach((el) => {
      const val = el.getAttribute('data-value');
      const target = document.querySelector(`[data-secondary-size-variant-selector][data-value="${val}"]`);
      if (target) target.classList.add('ProductOption__variant--sold-out');
    });
  });
  //Monetate Script
  const quickviewElement = document.getElementById('Quickview');
  const quickviewElement2 = document.getElementById('QuickView');

  const cartRows = [];
  if (window.cart && window.cart.items && window.cart.items.length > 0) {
    // window.cart.items.forEach((cartItem, index) => {
    window.cart.items.forEach((cartItem) => {
      var price = formatMoney(cartItem.price, theme.moneyFormat);
      price = price.replace(/[$A-Za-z,\s]+/g, '');
      if (!/^\d/.test(price)) {
        price = price.slice(1);
      }
      const cartRow = {
        productId: cartItem.product_id.toString(),
        quantity: cartItem.quantity.toString(),
        unitPrice: price,
        currency: Shopify.currency.active.toString(),
        sku: cartItem.variant_id.toString(),
      };

      cartRows.push(cartRow);
    });
  }

  if (
    (quickviewElement && quickviewElement.classList.contains('Modal--open')) ||
    (quickviewElement2 && quickviewElement2.classList.contains('Modal--open'))
  ) {
    window.monetateQ = window.monetateQ || [];

    window.monetateQ.push([
      'addProductDetails',
      [
        {
          productId: product_json.id.toString(),
          sku: variant.id.toString(),
        },
      ],
    ]);
    window.monetateQ.push(['addCartRows', cartRows]);
    window.monetateQ.push(['setPageType', 'quickview']);
    window.monetateQ.push(['trackData']);
  } else {
    window.monetateQ = window.monetateQ || [];

    window.monetateQ.push([
      'addProductDetails',
      [
        {
          productId: product_json.id.toString(),
          sku: variant.id.toString(),
        },
      ],
    ]);
    window.monetateQ.push(['addCartRows', cartRows]);
    window.monetateQ.push(['setPageType', 'product']);
    window.monetateQ.push(['trackData']);
  }
};

export default updateSelectedVariant;
